import React, { useEffect } from 'react'
import '.././PopupCommonStyle.css'
import styles from './Style.module.css'
import { BtnPrimary } from '../../Buttons/BtnPrimary';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useSchedule } from '../../../Context/Schedule/ScheduleContext';
import { STORAGE_KEYS } from '../../../Utils/SessionStorage';

export const SlotUnavailablePopup = ({
  active,
  message,
  onClose,
}) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { setSelectedTime } = useSchedule();

  useEffect(() => {
    if (!active) return;
    // Refetch mounted pickers now and clear cached data for the return to /time.
    queryClient.resetQueries({ queryKey: ['bookingDates'] });
    queryClient.resetQueries({ queryKey: ['bookingSlots'] });
  }, [active, queryClient]);

  const handleChooseAnotherSlot = () => {
    setSelectedTime('');
    sessionStorage.removeItem(STORAGE_KEYS.TIME);
    onClose();
    navigate('/time');
  };

  return (
    <div className={`${styles.slotUnavailablePopup} popup ${active ? "show" : ""}`}>
      <div className={`${styles.popHeader} popup-header`}>
        <h2 className="title">Slot No Longer Available</h2>
        <h6 className="titleSub">
          {message || "This slot is no longer available. Please choose another slot/date."}
        </h6>
      </div>
      <div className="popup-body"></div>
      <div className={`${styles.footer} popup-footer`}>
        <BtnPrimary
          label="Choose Another Slot"
          handleClick={handleChooseAnotherSlot}
          customClass="w-100 no-icon"
        />
      </div>
    </div>
  )
}
